import i18n from '@/locales/i18n';

export function getCheckoutBuilderLanguage(currencyCode = 'BRL') {
  return String(currencyCode || 'BRL').trim().toUpperCase() === 'USD' ? 'en' : 'pt';
}

export function translateCheckoutBuilder(currencyCode, key, options) {
  const language = getCheckoutBuilderLanguage(currencyCode);
  const fixedT = i18n.getFixedT(language, 'translations');

  return fixedT(`checkoutBuilder.${key}`, options);
}

export function getCheckoutPaymentMethodLabel(currencyCode, paymentMethod) {
  return translateCheckoutBuilder(currencyCode, `paymentMethods.${paymentMethod}`, {
    defaultValue: paymentMethod || '',
  });
}
